import type {
  PresignedUrl,
  StartCampaignResultExportRequest,
} from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

// campaign has 1:1 relationship with campaign export so using campaign id as export id
export type CampaignExportStore = StoreEntity<
  PresignedUrl & StartCampaignResultExportRequest,
  'campaignId',
  {},
  StartCampaignResultExportRequest
>;

export const useCampaignExportStore = apiStoreFactory<
  CampaignExportStore['entity'],
  CampaignExportStore['id'],
  CampaignExportStore['filter'],
  CampaignExportStore['createInput'],
  CampaignExportStore['updateInput']
>(
  STORE.CAMPAIGN_EXPORT,
  { entityIdKey: 'campaignId', supportPagination: false },
  {
    create: async (presignedUrlCreate, { dialbunnyApi }) => {
      await dialbunnyApi.startCampaignResultExport(presignedUrlCreate);

      return { ...presignedUrlCreate, url: '' };
    },
    read: async (campaignId, { dialbunnyApi }) => {
      const result = await dialbunnyApi.getCampaignResultExportUrl({
        campaignId,
      });

      return { ...result, campaignId };
    },
  },
);
